import styled from 'styled-components';

import { flexStart } from '../../../style/reusableStyle';

export const ViewProposalContainerStyled = styled.div``;

export const ActionsContainer = styled.div`
  ${flexStart};
  gap: 24px;
  margin-top: 10px;
`;
